import { render, staticRenderFns } from "./ItemDescription.vue?vue&type=template&id=25ae112e&"
import script from "./ItemDescription.vue?vue&type=script&lang=ts&"
export * from "./ItemDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports